import React, { Component } from 'react'
import { TxPage } from '../../../components'

class BlockListPage extends Component {
    render() {
        return <TxPage {...this.props} />
    }
}
export default BlockListPage
